import PropTypes from 'prop-types'

export const IssueSeverityOptionsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    colour: PropTypes.string.isRequired,
  })
)
